import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import ScrollableAnchor from "react-scrollable-anchor";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import {useRecoilState, useRecoilValue} from "recoil";
import {answerState, surveyDataState,} from "../../state/globalState";
import RadioOptionList from "../common/RadioOptionList";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import {useStyles} from "../survey/Survey1";
/**********************************************************************
 * ▷ Styled Component Section
 **********************************************************************/
const Box = styled.div`
  .survey-type-1{
      
  }
  .survey-type-2{
    padding-left: 30px;
  }
  .survey-type-3{
    padding-left: 60px;
  }
  .survey-type-4{
    padding-left: 100px;
  }  
  .survey-type-5{
    padding-left: 120px;
  }
`;

/**
 * 설문 문항 컴포넌트
 */
const RadioType = (props) => {
    const {step } = props
    const surveyData = useRecoilValue(surveyDataState);
    // const answer = useRecoilValue(answerState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const matches = useMediaQuery('(max-width:600px)');
    const classes = useStyles();
    const [visible, setVisible] = useState(!surveyData[step].hasOwnProperty('visible'));

    useEffect(()=>{
        if(surveyData[step].hasOwnProperty('visible')){
            const visibleCondition = surveyData[step].visible;
            if(answer[visibleCondition.column] === visibleCondition.value){
                setVisible(true);
            }
            else{
                setVisible(false);
            }
        }
    }, [answer])

    const handleInputAnswer = (e) => {
        const { value } = e.target;
        const regexp = /\B(?=(\d{3})+(?!\d))/g;
        const onlyNums = value.replace(/[^0-9]/g, '');
        setAnswer({
            ...answer,
            ["step_74"]: onlyNums.replace(regexp, ',')
        });
    }

    return (
        <>
            {visible && (
                <ScrollableAnchor id={step.toString()}>
                    <Box>
                        <div className={`survey-type-${surveyData[step].type}`}>
                            <Container style={{background: 'transparent', marginBottom: surveyData[step].type === 5 ? '0':'10px'}}>
                                <SentenceForm
                                    title={surveyData[step].title}
                                    sentences={surveyData[step].questions}
                                    step={step}
                                />
                                {step === 74 ?
                                    <div className="textFieldContainer">
                                        <TextField
                                            key={'step_74'}
                                            className={matches ? classes.textFieldMobile : classes.textField}
                                            label="여기에 답변을 입력하십시오."
                                            placeholder=""
                                            margin="none"
                                            value={answer["step_74"]}
                                            onChange={(e) => handleInputAnswer(e)}
                                            // inputRef={(el) => addRefs(el, 4)}
                                        />
                                    </div>
                                    :
                                    <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                                    {/*<Divider />*/}
                                    {surveyData[step].text.length ? (
                                        <RadioGroup defaultValue="0" aria-label="" name="" row>
                                            <RadioOptionList step={step} column={`step_${step}`}/>
                                        </RadioGroup>
                                    ) : (<></>)}
                                </FormControl>}
                            </Container>
                        </div>
                    </Box>
            </ScrollableAnchor>)}
        </>
    );
};

export default RadioType;
